<template lang="pug">
  v-row
    v-col(cols=12 lg=8 order="1")
      v-text-field(
        v-model="search"
        rounded
        filled
        label="Наименование курса"
        @input="debouncedSearch"
      )
      course-management-list(
        v-if="!$loader.isLoading"
        v-model="loadMore"
        :courses="courses"
        hide-image
        @on-response="({ items }) => courses.push(...items)"
      )
    v-col(cols=12 lg=4 :order="isMobile ? -1 : 2")
      v-card(color="secondary" dark).pa-1.sdo-card
        v-card-text.text-center
          h1 Всего курсов
          p.my-3 {{ $tc('courses', total) }}
          permissions-wrapper(
            :roles="[$conf.ROLES.organization]"
          )
            v-btn(
              color="white"
              light
              outlined
              large
              :to="{ name: 'CourseCreate' }"
            ).mt-4
              span Создать новый
              v-icon mdi-plus
</template>

<script>
import _ from 'lodash';
import CourseManagementList from '../components/CourseManagementList.vue';

export default {
  components: {
    CourseManagementList,
  },
  data() {
    return {
      search: '',
      courses: [],
      total: null,
      loadMore: null,
    };
  },
  computed: {
    isMobile() {
      return !this.$vuetify.breakpoint.lgAndUp;
    },
  },
  created() {
    this.debouncedSearch = _.debounce(this.fetchCourses, 300);
    this.fetchCourses();
  },
  methods: {
    async fetchCourses() {
      let service = this.$conf.COURSE_SERVICE.organization;
      if (this.$user.isTeacher) {
        service = this.$conf.COURSE_SERVICE.supervisor;
      }

      this.$loader.start();
      const { items, loadMore, pagination } = await this.$api.courses.index(
        {
          expand: 'rules,prior_records,active_period_prior_records,course_units_count',
          sort: '-created_at',
          'search[name]': this.search || null,
        },
        service,
      );
      this.loadMore = loadMore;
      this.total = pagination.total;
      this.courses = items;
      this.$loader.stop();
    },
  },
};
</script>
